import Vue, { VNode } from "vue";
import { DirectiveBinding } from "vue/types/options";
import * as Sentry from "@sentry/vue";

Vue.directive("fallback", {
  inserted(el: HTMLElement, binding: DirectiveBinding, vnode: VNode) {
    try {
      if (!(el instanceof HTMLImageElement)) {
        return;
      }

      const fallbackAttr = el.getAttribute("fallback");
      const configCdn = vnode.context?.$config.cdn || "";
      const fallbackFromAttr = fallbackAttr ? configCdn + fallbackAttr : "";
      const fallbackFromBinding =
        typeof binding.value === "string"
          ? binding.value
          : binding.value?.fallBackImage || "";

      const fallbackSrc = fallbackFromBinding || fallbackFromAttr;
      if (!fallbackSrc) {
        return;
      }

      el.addEventListener("error", () => {
        if (el.src !== fallbackSrc) {
          el.src = fallbackSrc;
        }
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  },
});
